'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Clearfix = require('react-bootstrap/lib/Clearfix');

var _Clearfix2 = _interopRequireDefault(_Clearfix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Clearfix2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/Clearfix.js
// module id = 611
// module chunks = 0